<template>
  <div
    class="ws-amount-card"
    :class="{clickable:isClickable}"
    @click="$_onClick()"
  >
    <div
      v-if="hasButton"
      class="ws-amount-card_button"
    >
      <WsTextButton001
        primary
        font-size-lg
        no-padding
        :leading-icon="buttonIcon"
        @click="$_buttonClick()"
      >
        {{ buttonText }}
      </WsTextButton001>
    </div>
    <div
      v-if="title"
      class="ws-amount-card__title-wrap"
    >
      <div
        v-if="hasDot"
        :class="{green:green,red:red,yellow:yellow}"
        class="ll-add-member-card_title-label-dot"
      />
      <i
        v-if="icon"
        class="ll-add-member-card_label-icon"
        :class="icon"
        :style="{color:_labelColor}"
      />
      <p class="ll-add-member-card_title">
        {{ title }}
      </p>
    </div>
    <div
      class="ws-amount-card__content"
      :class="{'mt-sm':contentText}"
    >
      <p
        v-if="contentText"
        class="ws-amount-card__content-text"
      >
        {{ contentText }}
      </p>
      <p
        v-else
        class="ws-amount-card__content-number"
      >
        {{ number === 0 ? '-' : number }}<span
          v-if="unit && number > 0"
          class="ws-amount-card__content-unit"
        >{{ unit }}</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "WsAmountCard001",
  props: {
    nonBoxShadow: {
      type: Boolean,
      default: false,
    },
    hasDot: {
      type: Boolean,
      default: false,
    },
    yellow: {
      type: Boolean,
      default: false,
    },
    green: {
      type: Boolean,
      default: false,
    },
    red: {
      type: Boolean,
      default: false,
    },
    contentText: {
      type: String,
      default: "",
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    buttonIcon: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    isClickable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    number: {
      type: Number,
      default: 0,
    },
    unit: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    labelWidth: {
      type: Number,
      default: 0,
    },
    labelHeight: {
      type: Number,
      default: 0,
    },
    labelColor: {
      type: String,
      default: "",
    },
    labelBorderRadius: {
      type: Number,
      default: 0,
    },
    labelColorStatus: {
      type: Array,
      default() {
        return [];
      },
    },
    labelBoxShadowColor: {
      type: String,
      default: "",
    },
    backgroundImg: {
      type: String,
      default: "",
    },
    colorType: {
      type: String,
      default: "",
    },
  },
  computed: {
    _labelColor() {
      if (this.labelColorStatus.length === 0) return this.labelColor;
      let selectColor = this.labelColorStatus.find(
        (status) => status.type === this.colorType
      );
      return selectColor && selectColor.color ? selectColor.color : "";
    },
    _labelBoxShadow() {
      if (this.labelColorStatus.length === 0) return this.labelBoxShadowColor;
      let selectColor = this.labelColorStatus.find(
        (status) => status.type === this.colorType
      );
      return selectColor && selectColor.boxShadowColor
        ? selectColor.boxShadowColor
        : "";
    },
    _labelBackgroundImage() {
      if (this.labelColorStatus.length === 0) return this.backgroundImg;
      let selectColor = this.labelColorStatus.find(
        (status) => status.type === this.colorType
      );
      return selectColor && selectColor.backgroundImg
        ? selectColor.backgroundImg
        : "";
    },
  },
  methods: {
    $_onClick() {
      this.$emit("card-click");
    },
    $_buttonClick() {
      this.$emit("button-click");
    },
  },
};
</script>